

import { defineComponent } from "vue";
import { mapState, mapStores } from "pinia";


import DashboardGrid from '~/components/dashboard-grid.vue';
import DashboardHeaderEdit from './dashboard-edit-header.vue';
import DashboardAddWidgetModal from '~/pages/dashboard-edit/add-widget-modal';

import BasePage from '~/core/base-page';
import { Widget } from "~/models/widget.model";
import { useWidgetStore } from "~/store/widgets.store";
import { WidgetMode } from "~/components/widgets/widget.vue";
import { NavigationFailure } from "vue-router";

enum Mode {
    EDIT = 'edit',
    ADD = 'add'
}

export default defineComponent({

    extends: BasePage,

    components: {
        DashboardHeaderEdit,
        DashboardGrid,
        DashboardAddWidgetModal,
    },

    data() {
        return { 
            widgets: null as Widget[],
            WidgetMode,
            mode: Mode.EDIT,
            Mode: Mode,
        }
    },

    computed: {
        ...mapState(useWidgetStore, ['templates', 'defaults']),
        ...mapStores(useWidgetStore),
    },

    async mounted() {
        this.widgets = await this.widgetStore.load()
            .catch((error) => {
                this.$notifyError('Could not load widgets', error);
                return null;
            });
        
    },

    methods: {
        async onSubmit(): Promise<void> {
            try {
                await this.widgetStore.saveWidgets(this.widgets);
                this.$router.push({name: 'dashboard'})
            } catch(error) {
                this.$notifyError(this.$t('dashboard-edit.failure', error));
            }
        },

        async reset(): Promise<void | NavigationFailure> {
            return this.showLoading(
                this.widgetStore.reset()
                    .then(() => this.$router.push({name: 'dashboard'}))
                    .catch((error: Error) => this.$notifyError(this.$t('dashboard-edit.failure'), error))
            );
        },

        updateWidgets(widgets: Widget[]): void {
            if(!this.$refs['edit-grid']) {
                return;
            }

            this.widgets = widgets;

            //@ts-ignore
            this.$refs['edit-grid'].resetGrid();
        },

        onGridChange(widgets: Widget[]): void {
            this.widgets = widgets;
        },

        addWidget(): void {
            this.$refs['add-widget-modal']?.open();
        }
    }
})

